module.exports = __webpack_public_path__ + "img/12.a5307f64.png";